/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiVoxtralScheduleGet$Params {
  date?: string;
  channel?: string;
}

export function apiVoxtralScheduleGet(http: HttpClient, rootUrl: string, params?: ApiVoxtralScheduleGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiVoxtralScheduleGet.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('channel', params.channel, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiVoxtralScheduleGet.PATH = '/api/voxtral-schedule';
